export default __webpack_public_path__ + "static/media/ILPlatform_AboutUs.96b55de4.jpg";